import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=b08f8194&scoped=true&"
import script from "./NavLink.vue?vue&type=script&lang=js&"
export * from "./NavLink.vue?vue&type=script&lang=js&"
import style0 from "./NavLink.vue?vue&type=style&index=0&id=b08f8194&scoped=true&lang=css&"
import style1 from "./NavLink.vue?vue&type=style&index=1&id=b08f8194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08f8194",
  null
  
)

export default component.exports